module.exports = __webpack_public_path__ + "static/img/brand-3.4f3d4c9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/yiBrand/brand-3.png
// module id = KDZx
// module chunks = 0